const MuiTableHead = {
  styleOverrides: {
    root: {
      borderBottom: '1px solid #666666',
      width: '30%',
    },
  },
};

export default MuiTableHead;
